import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./i18n";
import {
  TopBar,
  Header,
  NavBar,
  AboutSection,
  ShopByCategory,
  FeaturesStrip,
  Footer,
} from "./components/TelecompShared";
import { ServicesSection, ContactSection } from "./components/Sections";
import { HeroA } from "./components/HeroDesigns";
import { InventoryDownloadSection } from "./components/InventoryDownload";
import { SubscribeSection } from "./components/Subscribe";
import { WhatsAppFloat } from "./components/WhatsApp";
import { PrivacyPage, TermsPage } from "./components/LegalPages";
import AdminPage from "./components/Admin";
import Catalog from "./components/Catalog";
import AnalyticsTracker from "./components/AnalyticsTracker";
import SitePopup from "./components/SitePopup";

const Chrome = ({ children }) => (
  <div className="App min-h-screen bg-white">
    <TopBar />
    <Header />
    <NavBar />
    {children}
    <Footer />
    <WhatsAppFloat />
  </div>
);

const HomePage = () => (
  <Chrome>
    <HeroA />
    <AboutSection />
    <ShopByCategory />
    <InventoryDownloadSection />
    <ServicesSection />
    <FeaturesStrip />
    <SubscribeSection />
    <ContactSection />
    <SitePopup />
  </Chrome>
);

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <AnalyticsTracker />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route
            path="/catalog"
            element={
              <Chrome>
                <Catalog />
              </Chrome>
            }
          />
          <Route path="/admin" element={<AdminPage />} />
          <Route
            path="/privacy"
            element={
              <Chrome>
                <PrivacyPage />
              </Chrome>
            }
          />
          <Route
            path="/terms"
            element={
              <Chrome>
                <TermsPage />
              </Chrome>
            }
          />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
